import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-empty-echeck-list',
    templateUrl: './empty-echeck-list.component.html',
    styleUrls: ['./empty-echeck-list.component.scss'],
})
export class EmptyEcheckistComponent {}
